import React from 'react';

import { Box, Typography } from '@mui/material';
import { useMerchant } from '../contexts/MerchantContext';
import { Button } from '../components/core';

type Props = {
  icon: React.ReactNode;
  title: string;
  paragraph: string;
  onClick: () => void;
  buttonText: string;
};

export const EmptyPage = ({ icon, title, paragraph, onClick, buttonText }: Props) => {
  const { canUpdateMerchantSettings } = useMerchant();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'secondary.light',
        border: '1px solid',
        borderColor: 'border.main',
        width: '100%',
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 700,
          width: '60%',
          textAlign: 'center',
          py: 5,
        }}
      >
        <Box sx={{ '& svg': { fontSize: 55, mb: 2 } }}>{icon}</Box>
        <Typography component="h3" variant="xxl" fontWeight="semibold" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Typography sx={{ mb: 2 }}>{paragraph}</Typography>
        <Button
          theme="primary"
          text={buttonText}
          onClick={onClick}
          disabled={!canUpdateMerchantSettings()}
          sx={{ mt: 2, px: 4 }}
        />
      </Box>
    </Box>
  );
};
